// extracted by mini-css-extract-plugin
export default {"container":"Io-z","ratingLayout":"Jo-z","ratingLabel":"Ko-z","nonInteractiveRatingLabel":"Lo-z"};